import { Component, OnInit, Inject } from "@angular/core";
import { PageEvent, MatTableDataSource } from "@angular/material";
import { Paginate } from "@model/Paginate";
import { User } from "@model/User";
import { InstitutionService } from "@service/institution.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-modal-reports",
  templateUrl: "./modal-reports.component.html",
  styleUrls: ["./modal-reports.component.scss"],
})
export class ModalReportsComponent implements OnInit {
  public displayedColumns: string[] = [
    "advisor",
    "student",
    "name",
    "description",
    "date",
  ];

  public pageEvent: PageEvent;
  public page: Paginate<User> = {
    page: 20,
    current: 0,
    total: 0,
  } as Paginate<User>;

  public dataSource = new MatTableDataSource<any>();
  public pageSizeOptions: number[] = [5, 10, 20];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      institution: string;
      isGeneral: boolean;
      startDate: string;
      endDate: string;
      projectId?: number;
    },
    public dialogRef: MatDialogRef<ModalReportsComponent>,
    private institutionService: InstitutionService
  ) {}

  ngOnInit() {
    if (this.data.isGeneral) {
      this.institutionService
        .getOrientations(
          this.data.institution,
          this.data.startDate,
          this.data.endDate
        )
        .subscribe((res) => {
          console.log(res);
          const rows = new Array<any>();
          res.forEach((item) => {
            rows.push({
              advisor: item.advisor_name,
              student: item.student_name,
              name: item.stage_description,
              description: item.orientation_description,
              date: new Date(
                item.started_at.replace(/-/g, ",")
              ).toLocaleDateString(),
            });
          });
          this.dataSource.data = [...rows];
        });
    } else {
      this.institutionService
        .getOrientationsByProject(
          this.data.projectId,
          this.data.startDate,
          this.data.endDate
        )
        .subscribe((res) => {
          const rows = new Array<any>();
          res.forEach((item) => {
            rows.push({
              advisor: item.advisor_name,
              student: item.student_name,
              name: item.stage_description,
              description: item.orientation_description,
              date: new Date(
                item.started_at.replace(/-/g, ",")
              ).toLocaleDateString(),
            });
          });
          this.dataSource.data = [...rows];
        });
    }
  }
}
